import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const ChiecLuocNgaPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24">
        {/* Breadcrumbs */}
        <div className="bg-gray-50 py-4 px-6">
          <div className="max-w-5xl mx-auto">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Link to="/" className="hover:text-rose-600 transition-colors">Trang chủ</Link>
              <span>/</span>
              <Link to="/van" className="hover:text-rose-600 transition-colors">Văn học</Link>
              <span>/</span>
              <span className="text-gray-900 font-medium">Chiếc lược ngà</span>
            </div>
          </div>
        </div>

        {/* Hero */}
        <section className="py-12 px-6 bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <img 
                src="https://public.readdy.ai/ai/img_res/86a7977b9fbae297c1c3c4221ba37fef.jpg"
                alt="Chiếc lược ngà"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>
            
            <h1 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Phân Tích Truyện Ngắn "Chiếc Lược Ngà" - Nguyễn Quang Sáng
            </h1>
            
            <div className="flex flex-wrap gap-4 mb-6">
              <span className="px-4 py-2 bg-rose-100 text-rose-700 rounded-full text-sm font-medium">
                📚 Văn học
              </span>
              <span className="px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-medium">
                🎓 Lớp 8
              </span>
              <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                ⏱️ 15 phút đọc
              </span>
              <span className="px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium">
                👁️ 8,234 lượt xem
              </span>
            </div>
          </div>
        </section>

        {/* Content */}
        <article className="py-16 px-6">
          <div className="max-w-5xl mx-auto">
            {/* Mục lục */}
            <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl p-8 mb-12 border-l-4 border-rose-500">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-file-list-line text-3xl text-rose-600"></i>
                Mục lục
              </h3>
              <ul className="space-y-3">
                <li><a href="#overview" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 1. Tổng quan về tác phẩm</a></li>
                <li><a href="#author" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 2. Tác giả Nguyễn Quang Sáng</a></li>
                <li><a href="#plot" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 3. Cốt truyện và nhân vật</a></li>
                <li><a href="#theme" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 4. Chủ đề và ý nghĩa</a></li>
                <li><a href="#art" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 5. Nghệ thuật kể chuyện</a></li>
                <li><a href="#symbol" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 6. Biểu tượng chiếc lược ngà</a></li>
                <li><a href="#summary" className="text-rose-600 hover:text-rose-700 font-medium flex items-center gap-2 hover:translate-x-2 transition-transform"><i className="ri-arrow-right-s-line"></i> 7. Tổng kết &amp; Ghi nhớ</a></li>
              </ul>
            </div>

            {/* 1. Tổng quan */}
            <section id="overview" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">1</span>
                Tổng Quan Về Tác Phẩm
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  <strong>"Chiếc lược ngà"</strong> là một truyện ngắn nổi tiếng của nhà văn <strong>Nguyễn Quang Sáng</strong>, 
                  được xuất bản lần đầu năm 1966. Tác phẩm kể về câu chuyện tình yêu trong sáng, đẹp đẽ nhưng cũng đầy 
                  day dứt của hai nhân vật chính - Chàng và Nàng - qua hình ảnh chiếc lược ngà làm vật kỷ niệm.
                </p>

                <div className="bg-rose-50 border-l-4 border-rose-500 p-6 rounded-lg my-6">
                  <p className="text-gray-800 italic">
                    "Chiếc lược ngà không chỉ là một vật dụng thông thường mà còn là biểu tượng cho tình yêu, sự chờ đợi 
                    và nỗi đau của con người trong chiến tranh."
                  </p>
                </div>

                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Truyện được viết trong bối cảnh <strong>chiến tranh chống Mỹ</strong>, khi đất nước bị chia cắt làm hai miền 
                  Nam - Bắc. Câu chuyện phản ánh nỗi đau của hàng triệu người dân Việt Nam phải chịu cảnh ly biệt, gia đình 
                  tan vỡ vì chiến tranh. Qua đó, tác giả đã gửi gắm thông điệp về khát vọng hòa bình, mong muốn đất nước 
                  thống nhất để con người được sum họp bên nhau.
                </p>

                <p className="text-lg leading-relaxed text-gray-700">
                  Tác phẩm đã được đưa vào <strong>chương trình Ngữ văn lớp 8</strong> và trở thành một trong những truyện ngắn 
                  được yêu thích nhất, để lại ấn tượng sâu sắc trong lòng độc giả về tình yêu thương con người và khát vọng 
                  hòa bình của dân tộc.
                </p>
              </div>
            </section>

            {/* 2. Tác giả */}
            <section id="author" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">2</span>
                Tác Giả Nguyễn Quang Sáng
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <div className="grid md:grid-cols-2 gap-8 mb-8">
                  <div>
                    <img 
                      src="https://readdy.ai/api/search-image?query=Portrait%20of%20Vietnamese%20writer%20author%20with%20books%20and%20writing%20desk%20intellectual%20atmosphere%20literary%20aesthetic%20warm%20study%20room%20vintage%20style%20cultural%20heritage%20artistic%20photography&width=600&height=400&seq=author-portrait&orientation=landscape"
                      alt="Nhà văn Nguyễn Quang Sáng"
                      className="w-full h-64 object-cover rounded-xl shadow-lg"
                    />
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Tiểu sử</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-calendar-line text-rose-600 mt-1"></i>
                        <span><strong>Sinh năm:</strong> 1932 tại Hà Nội</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-map-pin-line text-rose-600 mt-1"></i>
                        <span><strong>Quê quán:</strong> Thôn Yên Sơn, xã Yên Phụ, Tây Hồ, Hà Nội</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-award-line text-rose-600 mt-1"></i>
                        <span><strong>Giải thưởng:</strong> Giải thưởng Nhà nước về Văn học Nghệ thuật</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-book-line text-rose-600 mt-1"></i>
                        <span><strong>Tác phẩm nổi bật:</strong> Chiếc lược ngà, Cô bé bán diêm, Một ngày rất lạnh...</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  <strong>Nguyễn Quang Sáng</strong> là một trong những nhà văn nổi tiếng của văn học Việt Nam hiện đại, 
                  đặc biệt xuất sắc trong thể loại <strong>truyện ngắn và văn học thiếu nhi</strong>. Ông có phong cách viết 
                  giản dị, gần gũi nhưng sâu sắc, thường khai thác đề tài về con người trong chiến tranh, về tình yêu thương 
                  và lòng nhân ái.
                </p>

                <p className="text-lg leading-relaxed text-gray-700">
                  Trong sự nghiệp sáng tác, Nguyễn Quang Sáng đã để lại nhiều tác phẩm giá trị như: <em>"Chiếc lược ngà"</em>, 
                  <em>"Một ngày rất lạnh"</em>, <em>"Cô bé bán diêm"</em>, <em>"Sợi tóc dài"</em>... Các tác phẩm của ông 
                  thường mang âm hưởng nhân văn sâu sắc, ca ngợi những phẩm chất tốt đẹp của con người và khát vọng hòa bình.
                </p>
              </div>
            </section>

            {/* 3. Cốt truyện */}
            <section id="plot" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">3</span>
                Cốt Truyện Và Nhân Vật
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">3.1. Tóm tắt cốt truyện</h3>
                
                <div className="space-y-6 mb-8">
                  <div className="bg-gradient-to-r from-rose-50 to-pink-50 p-6 rounded-xl border-l-4 border-rose-400">
                    <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-8 h-8 bg-rose-400 text-white rounded-full flex items-center justify-center text-sm">1</span>
                      Phần mở đầu - Gặp gỡ và yêu nhau
                    </h4>
                    <p className="text-gray-700">
                      Chàng và Nàng yêu nhau từ thời thanh xuân. Họ thường gặp nhau ở bờ sông, nơi có hàng dương xanh mát. 
                      Chàng thường chải tóc cho Nàng bằng chiếc lược ngà - món quà mà Nàng rất trân trọng.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-rose-50 to-pink-50 p-6 rounded-xl border-l-4 border-rose-400">
                    <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-8 h-8 bg-rose-400 text-white rounded-full flex items-center justify-center text-sm">2</span>
                      Phần thắt nút - Chiến tranh chia cắt
                    </h4>
                    <p className="text-gray-700">
                      Chiến tranh bùng nổ, Chàng phải lên đường đánh giặc. Trước khi đi, Chàng tặng Nàng chiếc lược ngà 
                      và hứa sẽ trở về. Nàng giữ chiếc lược như giữ niềm tin vào ngày Chàng trở lại. Nhiều năm trôi qua, 
                      Nàng vẫn kiên nhẫn chờ đợi.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-rose-50 to-pink-50 p-6 rounded-xl border-l-4 border-rose-400">
                    <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-8 h-8 bg-rose-400 text-white rounded-full flex items-center justify-center text-sm">3</span>
                      Phần kết - Gặp lại và nỗi đau
                    </h4>
                    <p className="text-gray-700">
                      Khi chiến tranh kết thúc, Chàng trở về nhưng không còn nhận ra Nàng - người đã già đi nhiều sau 
                      bao năm chờ đợi. Chỉ khi nhìn thấy chiếc lược ngà, Chàng mới nhận ra người yêu của mình. Câu chuyện 
                      kết thúc bằng nỗi đau xót sâu sắc về những gì chiến tranh đã cướp đi.
                    </p>
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">3.2. Nhân vật chính</h3>
                
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-white border-2 border-rose-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                    <h4 className="text-xl font-bold text-rose-700 mb-3 flex items-center gap-2">
                      <i className="ri-user-line"></i> Chàng
                    </h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-rose-500 mt-1"></i>
                        <span>Người yêu Nàng say đắm</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-rose-500 mt-1"></i>
                        <span>Tự nguyện lên đường bảo vệ Tổ quốc</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-rose-500 mt-1"></i>
                        <span>Luôn nhớ về người yêu suốt những năm chiến đấu</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-rose-500 mt-1"></i>
                        <span>Đau khổ khi nhận ra thời gian đã lấy đi thanh xuân của cả hai</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-pink-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                    <h4 className="text-xl font-bold text-pink-700 mb-3 flex items-center gap-2">
                      <i className="ri-user-smile-line"></i> Nàng
                    </h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-pink-500 mt-1"></i>
                        <span>Người con gái đẹp, dịu dàng</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-pink-500 mt-1"></i>
                        <span>Kiên nhẫn chờ đợi người yêu suốt nhiều năm</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-pink-500 mt-1"></i>
                        <span>Giữ gìn chiếc lược ngà như giữ tình yêu và niềm tin</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-pink-500 mt-1"></i>
                        <span>Biểu tượng cho người phụ nữ Việt Nam kiên cường</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* 4. Chủ đề */}
            <section id="theme" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">4</span>
                Chủ Đề Và Ý Nghĩa
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">4.1. Tình yêu trong chiến tranh</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Chủ đề chính của truyện là <strong>tình yêu giữa hai con người trong bối cảnh chiến tranh</strong>. 
                  Tác giả đã khắc họa một tình yêu trong sáng, đẹp đẽ nhưng đầy day dứt và đau thương. Chàng và Nàng 
                  yêu nhau thật lòng, nhưng chiến tranh đã chia cắt họ ra xa nhau. Dù vậy, tình yêu của họ vẫn mãnh liệt 
                  và bền vững qua thời gian.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">4.2. Sự hy sinh và chờ đợi</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Qua nhân vật Nàng, tác giả đã tôn vinh <strong>phẩm chất kiên nhẫn, thủy chung của người phụ nữ Việt Nam</strong>. 
                  Nàng đã dành cả thanh xuân để chờ đợi người yêu trở về, giữ gìn niềm tin và tình yêu như giữ gìn chiếc lược ngà. 
                  Đó là hình ảnh của hàng triệu người phụ nữ Việt Nam đã hy sinh tuổi thanh xuân, hạnh phúc của mình vì đất nước.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">4.3. Khát vọng hòa bình</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Tác phẩm còn gửi gắm <strong>thông điệp về hòa bình</strong>. Chiến tranh đã cướp đi tuổi thanh xuân, hạnh phúc 
                  của con người. Qua nỗi đau của Chàng và Nàng, tác giả kêu gọi mọi người trân trọng hòa bình, vì chỉ trong hòa bình, 
                  con người mới có được hạnh phúc trọn vẹn.
                </p>

                <div className="bg-gradient-to-br from-rose-100 to-pink-100 rounded-2xl p-8 my-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-lightbulb-line text-2xl text-rose-600"></i>
                    Ý nghĩa nhân văn sâu sắc
                  </h4>
                  <p className="text-gray-800 leading-relaxed">
                    "Chiếc lược ngà" không chỉ là câu chuyện tình yêu đơn thuần mà còn là bức tranh về cuộc sống con người 
                    trong chiến tranh - nơi tình yêu, ước mơ, hạnh phúc phải nhường chỗ cho sự hy sinh vì dân tộc. Tác phẩm 
                    khiến người đọc suy ngẫm về giá trị của hòa bình và trân trọng hơn cuộc sống yên ả ngày nay.
                  </p>
                </div>
              </div>
            </section>

            {/* 5. Nghệ thuật */}
            <section id="art" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">5</span>
                Nghệ Thuật Kể Chuyện
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">5.1. Cấu trúc truyện</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Truyện được kể theo <strong>cấu trúc ba hồi</strong> rõ ràng: mở đầu - thắt nút - kết thúc. Tác giả sử dụng 
                  kỹ thuật <strong>hồi tưởng</strong> khéo léo, xen kẽ giữa hiện tại và quá khứ, tạo nên sự đan xen cảm xúc 
                  và làm nổi bật sự tương phản giữa quá khứ tươi đẹp và hiện tại đau thương.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">5.2. Ngôn ngữ giản dị, sâu sắc</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Nguyễn Quang Sáng viết bằng <strong>ngôn từ giản dị, gần gũi</strong> nhưng đầy cảm xúc. Tác giả không dùng 
                  những từ ngữ hoa mỹ mà chỉ cần những câu chữ bình dị đã khiến người đọc cảm nhận được nỗi đau sâu sắc của 
                  nhân vật. Điều này thể hiện tài năng đặc biệt của ông trong việc <strong>chạm đến trái tim người đọc bằng 
                  sự chân thật</strong>.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">5.3. Kỹ thuật tả cảnh và tả người</h3>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Tác giả khéo léo sử dụng cảnh vật để <strong>gợi cảm xúc và tăng tính biểu cảm</strong> cho câu chuyện:
                </p>

                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-3">
                    <i className="ri-leaf-line text-green-600 text-xl mt-1"></i>
                    <span className="text-gray-700"><strong>Hàng dương bờ sông:</strong> Biểu tượng cho tình yêu trong sáng, 
                    nơi gắn liền với kỷ niệm đẹp của đôi lứa</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-time-line text-amber-600 text-xl mt-1"></i>
                    <span className="text-gray-700"><strong>Thời gian trôi:</strong> Được thể hiện qua sự thay đổi ngoại hình 
                    của Nàng, từ thiếu nữ xinh đẹp đến người phụ nữ già nua</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-contrast-2-line text-purple-600 text-xl mt-1"></i>
                    <span className="text-gray-700"><strong>Tương phản:</strong> Giữa hình ảnh Nàng ngày xưa và Nàng bây giờ 
                    tạo nên sự day dứt, đau xót</span>
                  </li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">5.4. Kết thúc mở và dư vị</h3>
                <p className="text-lg leading-relaxed text-gray-700">
                  Truyện kết thúc ở <strong>điểm cao trào cảm xúc</strong> khi Chàng nhận ra người yêu qua chiếc lược ngà. 
                  Tác giả không kể tiếp chuyện gì xảy ra sau đó, để lại <strong>dư vị sâu lắng</strong> cho người đọc. 
                  Kết thúc mở này khiến độc giả phải suy ngẫm và cảm nhận trọn vẹn nỗi đau của nhân vật.
                </p>
              </div>
            </section>

            {/* 6. Biểu tượng */}
            <section id="symbol" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">6</span>
                Biểu Tượng Chiếc Lược Ngà
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  <strong>Chiếc lược ngà</strong> không chỉ là món quà kỷ niệm mà còn là <strong>biểu tượng nhiều lớp nghĩa</strong> 
                  trong truyện:
                </p>

                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-rose-50 to-pink-50 p-6 rounded-xl border-l-4 border-rose-400">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-heart-line text-rose-600 text-xl"></i>
                      1. Biểu tượng của tình yêu
                    </h4>
                    <p className="text-gray-700">
                      Chiếc lược là món quà Chàng tặng Nàng, gắn liền với những kỷ niệm đẹp đẽ của đôi lứa. Nó tượng trưng 
                      cho tình yêu trong sáng, chân thành mà Chàng và Nàng dành cho nhau. Mỗi lần Chàng chải tóc cho Nàng 
                      bằng chiếc lược này là một cử chỉ yêu thương tế nhị và sâu sắc.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 rounded-xl border-l-4 border-purple-400">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-time-line text-purple-600 text-xl"></i>
                      2. Biểu tượng của sự chờ đợi và niềm tin
                    </h4>
                    <p className="text-gray-700">
                      Nàng giữ chiếc lược suốt bao năm chờ đợi, như cách mà Nàng giữ gìn niềm tin vào ngày Chàng trở về. 
                      Chiếc lược ngà trở thành vật duy nhất nối liền quá khứ với hiện tại, là chỗ dựa tinh thần giúp Nàng 
                      vượt qua những năm tháng cô đơn.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-6 rounded-xl border-l-4 border-amber-400">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-memorial-line text-amber-600 text-xl"></i>
                      3. Biểu tượng của thời gian và sự mất mát
                    </h4>
                    <p className="text-gray-700">
                      Trong khi con người thay đổi, già đi theo thời gian, chiếc lược ngà vẫn giữ nguyên vẻ đẹp ban đầu. 
                      Sự tương phản này nhấn mạnh tàn khốc của chiến tranh - đã cướp đi thanh xuân, hạnh phúc của con người. 
                      Chỉ có chiếc lược là vật duy nhất không đổi, nhắc nhở về một thời đã mất.
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-xl border-l-4 border-green-400">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-user-heart-line text-green-600 text-xl"></i>
                      4. Vật để nhận diện và kết nối
                    </h4>
                    <p className="text-gray-700">
                      Cuối cùng, chính chiếc lược ngà giúp Chàng nhận ra Nàng - người mà thời gian đã thay đổi quá nhiều. 
                      Nó là cầu nối cuối cùng, là bằng chứng duy nhất về một tình yêu đã từng tồn tại, và giờ đây vẫn còn 
                      đó dù đã trải qua bao thăng trầm.
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-rose-100 via-pink-100 to-purple-100 rounded-2xl p-8 my-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-medal-line text-2xl text-rose-600"></i>
                    Giá trị biểu tượng độc đáo
                  </h4>
                  <p className="text-gray-800 leading-relaxed">
                    Sự lựa chọn "chiếc lược ngà" làm biểu tượng trung tâm cho thấy tài năng của Nguyễn Quang Sáng. 
                    Đây là vật dụng giản dị nhưng mang nhiều ý nghĩa, vừa gần gũi với đời sống vừa chứa đựng nhiều 
                    tầng sâu về cảm xúc và triết lý. Chiếc lược ngà đã trở thành một trong những hình ảnh biểu tượng 
                    đẹp nhất trong văn học Việt Nam về tình yêu và chiến tranh.
                  </p>
                </div>
              </div>
            </section>

            {/* 7. Tổng kết */}
            <section id="summary" className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-rose-500 text-white rounded-full flex items-center justify-center text-xl">7</span>
                Tổng Kết &amp; Ghi Nhớ
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-8 mb-8 border-2 border-rose-200">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <i className="ri-bookmark-line text-rose-600"></i>
                    Những điểm cần ghi nhớ
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-rose-600 text-xl mt-1"></i>
                      <span className="text-gray-800"><strong>Tác giả:</strong> Nguyễn Quang Sáng - nhà văn nổi tiếng với thể loại truyện ngắn</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-rose-600 text-xl mt-1"></i>
                      <span className="text-gray-800"><strong>Chủ đề chính:</strong> Tình yêu trong chiến tranh, sự hy sinh và chờ đợi, khát vọng hòa bình</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-rose-600 text-xl mt-1"></i>
                      <span className="text-gray-800"><strong>Biểu tượng:</strong> Chiếc lược ngà - tượng trưng cho tình yêu, niềm tin, thời gian và sự mất mát</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-rose-600 text-xl mt-1"></i>
                      <span className="text-gray-800"><strong>Nghệ thuật:</strong> Ngôn ngữ giản dị nhưng sâu sắc, kỹ thuật hồi tưởng, kết thúc mở</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-rose-600 text-xl mt-1"></i>
                      <span className="text-gray-800"><strong>Ý nghĩa:</strong> Tôn vinh tình yêu, phê phán chiến tranh, khát vọng hòa bình</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 mb-8 border-2 border-amber-200">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <i className="ri-lightbulb-line text-amber-600"></i>
                    Mẹo phân tích và viết bài
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Tập trung phân tích <strong>biểu tượng chiếc lược ngà</strong> - đây là điểm đặc sắc nhất của truyện</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Nêu rõ <strong>bối cảnh chiến tranh</strong> và ảnh hưởng của nó đến cuộc đời nhân vật</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Phân tích <strong>hình ảnh tương phản</strong> giữa quá khứ và hiện tại của Nàng</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Dẫn chứng các <strong>đoạn miêu tả cảm xúc</strong> để làm rõ nghệ thuật của tác giả</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-amber-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Liên hệ với <strong>hoàn cảnh lịch sử</strong> Việt Nam thời kỳ chiến tranh chống Mỹ</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-2xl p-8 border-2 border-red-200">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <i className="ri-error-warning-line text-red-600"></i>
                    Lỗi thường gặp khi phân tích
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-close-circle-fill text-red-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Chỉ tóm tắt cốt truyện mà không phân tích sâu ý nghĩa và nghệ thuật</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-close-circle-fill text-red-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Bỏ qua vai trò của biểu tượng chiếc lược ngà trong việc thể hiện chủ đề</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-close-circle-fill text-red-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Không nêu rõ bối cảnh lịch sử và ảnh hưởng của nó đến tác phẩm</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-close-circle-fill text-red-500 text-xl mt-1"></i>
                      <span className="text-gray-800">Viết chung chung, không dẫn chứng cụ thể từ văn bản</span>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Related lessons */}
            <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl p-8 mt-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <i className="ri-book-open-line text-rose-600"></i>
                Bài học liên quan
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Link 
                  to="/van/phan-tich-bai-tho-viet-bac" 
                  className="flex items-center gap-3 p-4 bg-white rounded-xl hover:shadow-lg transition-all group cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-2xl text-rose-600 group-hover:translate-x-1 transition-transform"></i>
                  <span className="text-gray-800 font-medium">Phân tích bài thơ Việt Bắc</span>
                </Link>
                <Link 
                  to="/van/nghi-luan-xa-hoi" 
                  className="flex items-center gap-3 p-4 bg-white rounded-xl hover:shadow-lg transition-all group cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-2xl text-rose-600 group-hover:translate-x-1 transition-transform"></i>
                  <span className="text-gray-800 font-medium">Hướng dẫn viết văn Nghị luận xã hội</span>
                </Link>
              </div>
            </div>
          </div>
        </article>
      </main>
      
      <Footer />
    </div>
  );
};

export default ChiecLuocNgaPage;